var _path, _ellipse, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShape1 = function SvgShape1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "100%",
      height: "auto"
    },
    viewBox: "0 0 893 317"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#shape-1_svg__a)",
    d: "M0 0h3v157H0z",
    transform: "matrix(1 0 0 -1 445 157)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shape-1_svg__b)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 446.5,
    cy: 96.318,
    fill: "url(#shape-1_svg__c)",
    fillOpacity: 0.8,
    rx: 4.5,
    ry: 55.073
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shape-1_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 446.5,
    cy: 160.5,
    r: 10.5,
    fill: "url(#shape-1_svg__e)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shape-1_svg__f)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "shape-1_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 160h893v157H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shape-1_svg__g)",
    fillOpacity: 0.5,
    d: "M0 160h893v157H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shape-1_svg__h)",
    d: "M0 161h893v-2H0z",
    mask: "url(#shape-1_svg__i)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-1_svg__a",
    x1: 1.5,
    x2: 1.5,
    y1: 0,
    y2: 157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-1_svg__e",
    x1: 446.5,
    x2: 446.5,
    y1: 157,
    y2: 171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-1_svg__h",
    x1: 834.5,
    x2: 50.5,
    y1: 160,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shape-1_svg__b",
    width: 21,
    height: 122.146,
    x: 436,
    y: 35.245,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_105_973",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shape-1_svg__d",
    width: 59,
    height: 59,
    x: 417,
    y: 131,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 5,
    result: "effect1_dropShadow_105_973"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.701961 0 0 0 0 0.192157 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_105_973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shape-1_svg__f",
    width: 915,
    height: 179,
    x: -11,
    y: 149,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_105_973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_105_973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shape-1_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 55.0728 -4.5 0 446.5 96.318)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shape-1_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 78 -443.656 0 446.5 160)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgShape1;